import { lazy } from 'react';
import Loadable from 'ui-component/Loadable';
import type { RouteObject } from 'react-router-dom';

const AddressesPage = Loadable(lazy(() => import('./components/AddressesPage')));
const ReviewsPage = Loadable(lazy(() => import('./components/ReviewsPage')));
const CardsPage = Loadable(lazy(() => import('./components/CardsPage')));
const CarriersPage = Loadable(lazy(() => import('./components/CarriersPage')));
const ProfilePage = Loadable(lazy(() => import('./components/ProfilePage')));

/**
 * This feature's own routes, composed into the app router by whichever legacy route file
 * still owns this path prefix — src/routes/AuthenticatedRoutes.jsx today, src/app/router.tsx
 * once that exists (AGENTS.md §1). InvoicesPage has no route of its own: it is only ever
 * rendered as a tab inside the profile page, same as it was before this migration.
 *
 * /profile lives in this feature rather than a features/profile of its own: three of its
 * four tabs ARE this feature's screens (addresses, invoices, reviews), and a separate
 * feature would have to import them across the boundary the architecture forbids.
 */
export const accountRoutes: RouteObject[] = [
  {
    path: '/account/addresses',
    element: <AddressesPage />
  },
  {
    path: '/profile',
    element: <ProfilePage />
  },
  {
    path: '/account/reviews',
    element: <ReviewsPage />
  },
  {
    path: '/account/cards',
    element: <CardsPage />
  },
  {
    path: '/account/carriers',
    element: <CarriersPage />
  }
];
